/**
 * @file schemaUtilities.js
 * @description functions to assist using fieldSchemas
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Mar 23, 2022 17:24
 */
import _ from 'lodash';

import { arrayDeepCopy, objectKeyExists, stringExists } from 'src/@common/utilities';

export function findOptions(fieldSchema, fieldName) {
    let options = [];

    if (fieldSchema?.[fieldName] &&
        objectKeyExists(fieldSchema[fieldName], 'options')) {

        options = arrayDeepCopy(fieldSchema[fieldName].options);
    }

    return options;
}

export function findLabel(fieldSchema, fieldName) {
    let label = '';

    if (fieldSchema?.[fieldName]) {
        label = fieldSchema[fieldName].label;
    }

    if (!stringExists(label)) {
        label = _.startCase(fieldName)
    }

    return label;
}

export function findHelpText(fieldSchema, fieldName) {
    let helpText = '';

    if (fieldSchema?.[fieldName]) {
        helpText = fieldSchema[fieldName].helpText;
    }

    return helpText;
}

export function findWidth(fieldSchema, fieldName) {
    // note: if width is not specified in the schema,
    // returns a default width
    let width = 250;

    if (fieldSchema?.[fieldName]) {
        if (fieldSchema[fieldName].width) {
            width = fieldSchema[fieldName].width;
        }
    }

    return width;
}
